export * from './Matching/MatchingQuestion.component';
export * from './Domino/DominoQuestion.component';
